module.exports = "<div class=\"animated fadeIn text-center mt-4\">\n  <h1>Where are you?!</h1>\n</div>\n"